var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretakerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-786 -1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0H64A10,10,0,0,1,74,10V64A10,10,0,0,1,64,74H10A10,10,0,0,1,0,64V10A10,10,0,0,1,10,0Z",
    transform: "translate(786 1659)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(833 1708)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(792.521 1656.868)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.478 18.132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.746,50.516c-.259-.2-2.317-1.758-8.027-2.137a2.147,2.147,0,0,1-.909-.436,4.588,4.588,0,0,1-.993-.8c-.437-.522-.931-.961-1.346-1.54-2.776-3.87-5.5-4.647-5.9-4.8-.542-.261-2.617.06-1.62,1.444.063.01,3.174,4.38,3.376,4.73a7.246,7.246,0,0,0,1.141,1.3c.347.4.731.759,1.085,1.148a18.652,18.652,0,0,1-2.466-1.694,5.286,5.286,0,0,1-.484-.837c-.2-.316-.4-.625-.616-.93-.266-.381-.534-.76-.816-1.129-.36-.469-.734-.928-1.105-1.389a10.2,10.2,0,0,1-.682-.864,1.5,1.5,0,0,1,1.156-2.487c-.049-.171-.52-4.666-.6-5.42C3.7,32.506,3.47,30.9,2.228,30.464a.647.647,0,0,0-.785.177,8.529,8.529,0,0,0-.532,2.865A74,74,0,0,0,.5,41.336c.07,1.336,4.22,10.528,5.413,11.948s10.52,6.8,10.52,6.8c.312.259,2.039,1.589,2.039,3.333V67.2l10.056.012.009-3.474c.023-.642.133-1.281.21-1.92a7.22,7.22,0,0,0-.058-2.647C27.518,53.959,23.216,50.88,22.746,50.516Z",
    transform: "translate(-0.478 -24.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,33.506a8.538,8.538,0,0,0-.532-2.865.648.648,0,0,0-.785-.177c-1.241.437-1.474,2.042-1.708,4.208-.083.755-.553,5.249-.6,5.42a1.5,1.5,0,0,1,1.156,2.487,9.929,9.929,0,0,1-.682.864c-.371.461-.746.92-1.106,1.389-.282.368-.55.748-.815,1.129-.212.305-.421.613-.616.93a5.2,5.2,0,0,1-.484.837,18.636,18.636,0,0,1-2.466,1.694c.354-.389.739-.752,1.086-1.148a7.244,7.244,0,0,0,1.141-1.3c.2-.349,3.314-4.719,3.376-4.73,1-1.384-1.079-1.705-1.62-1.444-.406.153-3.127.93-5.9,4.8-.415.579-.909,1.019-1.346,1.54a4.576,4.576,0,0,1-.993.8,2.147,2.147,0,0,1-.909.436c-5.71.379-7.767,1.935-8.027,2.137-.47.364-4.771,3.443-5.939,8.655a7.209,7.209,0,0,0-.058,2.647c.077.64.187,1.278.21,1.92l.009,3.474L76.19,67.2V63.414c0-1.744,1.727-3.074,2.039-3.333,0,0,9.327-5.376,10.52-6.8s5.342-10.612,5.413-11.948A73.817,73.817,0,0,0,93.75,33.506Z",
    transform: "translate(-34.767 -24.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.473,
    cy: 4.473,
    r: 4.473,
    transform: "translate(19.834 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.349,
    cy: 4.349,
    r: 4.349,
    transform: "translate(30.76 1.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,54.052c.515-.474,1-.874,1.416-1.189l.063-.048a10.53,10.53,0,0,1,3.7-1.642L56.8,48.537V46a24.059,24.059,0,0,1,1.252,4.967,26.921,26.921,0,0,1,3.337-.506c-1.013-6.231-2.567-9.024-6.148-11.219a11.234,11.234,0,0,0-1.808-.807l-1.084,1.091-1.05-1.1-.011,0a12.339,12.339,0,0,0-3.762,2.417,11.948,11.948,0,0,0-3-2.519,11.579,11.579,0,0,0-1.861-.829l-1.114,1.121-1.08-1.134-.011,0A9.606,9.606,0,0,0,38.2,38.685c-3.386,2.277-4.862,5.29-5.848,11.764a27.02,27.02,0,0,1,3.434.514,28.858,28.858,0,0,1,1.186-5.18V51.25c0,.005,0,.01,0,.016a10.155,10.155,0,0,1,3.377,1.55l.062.047c.417.316.9.717,1.421,1.193a6.441,6.441,0,0,1,4.373-3.77l.008,0,.7.737.7-.738.009,0A6.428,6.428,0,0,1,52,54.052Zm-5.088-3.936a3.026,3.026,0,1,1,3-3.026A3.028,3.028,0,0,1,46.914,50.116Z",
    transform: "translate(-17.206 -28.285)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretakerIcon1);
export default __webpack_public_path__ + "static/media/caretaker-icon1.6d05f49997e88a9b256e2f92b7edccd8.svg";
export { ForwardRef as ReactComponent };